import { combineReducers } from 'redux';
import userInfoReducer from './slices/userInfoSlice';
import menuReducer from './slices/menuSlice';

const rootReducer = combineReducers({
    userInfo: userInfoReducer,
    menu: menuReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
//
// export const isAuthenticated = (state: RootState): boolean => !!(state.userInfo.token && state.userInfo.token !== '');
//
// export const useAuthenticated = (): boolean => {
//     return useSelector(isAuthenticated);
// };

export default rootReducer;
